import * as STD from '@emersya/mpa-std-lib';

export class Tax {

	static isSerializedTax(something : any) : something is Tax.ISerialized {
		return something &&
			typeof something === 'object' &&
			'id' in something &&
			typeof something.id === 'string' &&
			'value' in something &&
			typeof something.value === 'number' &&
			'type' in something &&
			[ 'percent', 'value' ].includes(something.type);
	};

	static deserialize(serialized : Tax.ISerialized) {
		return new this(
			serialized.id,
			new STD.math.BigNumber(serialized.value),
			serialized.type
		);
	};

	readonly id : string;
	readonly value : STD.math.BigNumber;
	readonly type : Tax.TType;

	serialize() : Tax.ISerialized {
		return {
			id :    this.id,
			value : this.value.toNumber(),
			type :  this.type
		};
	};

	constructor(
		id : string,
		value : STD.math.BigNumber,
		type : Tax.TType
	)
	{
		this.id = id;
		this.value = value;
		this.type = type;
	};
};
export namespace Tax {
	export type TType = 'percent' | 'value';

	export interface ISerialized {
		readonly id : string;
		readonly value : number;
		readonly type : TType;
	};
}
